<template>
  <v-container v-if="examination && patient && dataKeysLen > 0" fluid grid-list-md class="mb-3 pa-0">
    <v-layout wrap>
      <v-flex v-for="item  in infoList" :key="item.text">
        <text-with-label :text="item.text" :label="item.label" />
      </v-flex>
      <v-flex v-if="showStatusButton" sm0 md4 lg2>
        <v-menu offset-y >
          <v-chip 
            slot="activator" 
            label 
            outline 
            :color="reportStatusColors[getReportStatus(examination.reportStatus)]"
            class="ml-0"
          >
            {{ getReportStatus(examination.reportStatus) }}
          </v-chip>
          <v-list>
            <v-list-tile
              v-for="item in reportStatus"
              :key="item"
              @click="$emit('reportStatusChange', item)"
            >
              <v-list-tile-title>{{ item }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex sm6 md8 lg12 xl3 class="text-xs-right">
        <slot name="right" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import common from '@/utils/common'
  import forms from '@/utils/forms'
  import TextWithLabel from './TextWithLabel.vue'

	export default {
		name: 'ExaminationInfo',

    components: {
      TextWithLabel
    },

		props: {
      examination: {
        type: Object,
        required: true
      },

      patient: {
        type: Object,
        required: true
      },

      examinationTypeList: {
        type: Array,
        required: true
      },

      showStatusButton: {
        type: Boolean,
        default: false
      }
    },

		data () {
			return {
        reportStatus: ['Unedited', 'Editing', 'Finalized'],

        reportStatusColors: {
          'Unedited': 'primary',
          'Editing': 'orange',
          'Finalized': 'green'
        },

        listOfKeys: [
          {
            key: 'date',
            source: 'examination',
            label: 'Date'
          },
          {
            key: 'examination_typeID',
            source: 'examination',
            label: 'Examination Type'
          },
          {
            key: 'no',
            source: 'patient',
            label: 'Medical Record'
          },
          {
            key: 'accNo',
            source: 'examination',
            label: 'Examination Record'
          },
          {
            key: 'name',
            source: 'patient',
            label: 'Name'
          },
          {
            key: 'gender',
            source: 'patient',
            label: 'Gender'
          },
          {
            key: 'birthday',
            source: 'patient',
            label: 'Age'
          }
        ]
			}
		},

		computed: {
      dataKeysLen () {
        return Object.keys(this.examination).length
      },

      getExaminationType () {
        return this.examinationTypeList.filter(type => type.id === this.examination.examination_typeID)
      },

      infoList () {
        return this.listOfKeys.map(item => {
          const key = item.key

          let obj = {
            label: item.label
          }

          if (key === 'examination_typeID') {
            obj.text = this.getExaminationType[0].examination_type
          } else if (key === 'birthday') {
            const age = common.calculageAge(this[item.source][key], 'YYYY-MM-DD')
            obj.text = age.toString()
          } else if (key === 'gender') {
            obj.text = common.getGender(this[item.source][key])
          } else {
            obj.text = this[item.source][key]
          }

          return obj
        })
      }
		},

		methods: {
      getReportStatus: (status) => forms.getReportStatus(status)
		}
	}
</script>

<style lang="scss">
  @import '@/styles/components/examinationInfo.scss';
</style>
